import React from 'react';
import { useTranslation } from 'react-i18next';
import { Pressable } from 'react-native';
import { StatusTag } from '../crop-circle/Components/Tag';

export type PendingTagState = 'pending' | 'failed';

export interface PendingTagProps {
  /** `pending` waits to sync; `failed` needs the user. */
  state: PendingTagState;
  /** Tapping a failed tag; a pending tag is not pressable. */
  onPress?: () => void;
  testID?: string;
}

/** Marks a list row whose submission is still on this device. */
export const PendingTag: React.FC<PendingTagProps> = ({
  state,
  onPress,
  testID,
}) => {
  const { t } = useTranslation();
  const failed = state === 'failed';
  const tag = (
    <StatusTag
      variant={failed ? 'error' : 'neutral'}
      text={t(failed ? 'offline.pending.notSynced' : 'offline.pending.tag')}
      testID={testID}
    />
  );
  if (!failed || !onPress) return tag;
  return (
    <Pressable
      onPress={(event) => {
        // A tag inside a pressable row must not also open the row.
        event?.stopPropagation?.();
        onPress();
      }}
      accessibilityRole="button"
      accessibilityLabel={t('offline.pending.notSyncedAction')}
      hitSlop={8}
    >
      {tag}
    </Pressable>
  );
};

PendingTag.displayName = 'PendingTag';
